import { createContext } from 'react';

import type { ISideSheetContextValue } from './types';

export const SideSheetContext = createContext<ISideSheetContextValue | undefined>(undefined);
